// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  deferrable: "EconomicFutures__deferrable",
  "endnote-head": "EconomicFutures__endnote-head",
  "endnote-head-lead": "EconomicFutures__endnote-head-lead",
  page: "EconomicFutures__page",
};
